import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  bordered: false,
  style: {"width":"1060px"},
  class: "table fixed-column-1"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "text-muted" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "manager-fee" }
const _hoisted_6 = { class: "chart-container" }

import { ref } from "vue";
import AlertPopup from "../popup/AlertPopup.vue";
import ChartCustome from "../chart/ChartCustome.vue";
import { useRouter } from "vue-router";
import { normalizeFloat } from "@app/@turnkeyidutils";
import { screenSizes } from "@/helper/index";
import { NAvatar, NButton, NIcon, NPopover, NTag, NTooltip, NTable } from "naive-ui";
interface IProps {
  pammManager: any;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'GridTableMoneyManager',
  props: {
    pammManager: {}
  },
  setup(__props: any) {

const isOpen = ref(false);
const router = useRouter();
const props = __props;

function countJoinFee(data) {
  if (data.manager_detail && data.manager_detail.IncentiveAccounts) {
    const initialValue = 0;
    const joinFee = data.manager_detail.IncentiveAccounts;

    const sumWithInitial = joinFee.reduce((accumulator, currentValue) => accumulator + currentValue.ManagementFee, initialValue);
    return sumWithInitial;
  }
  return 0;
}

function countPerformanceFee(data) {
  if (data.manager_detail && data.manager_detail.IncentiveAccounts) {
    const initialValue = 0;
    const joinFee = data.manager_detail.IncentiveAccounts;

    const sumWithInitial = joinFee.reduce((accumulator, currentValue) => accumulator + currentValue.IncentiveFee, initialValue);
    return sumWithInitial;
  }
  return 0;
}

function toLink(data) {
  if (!data.isUserInvestment) {
    router.push(`/pamm/investor-account/money-managers/${data.id ? data.id : data._id}`);
  } else {
    if (data.statusInvestment === `pending` || data.statusInvestment === `pending-disconnect`) {
      router.push(`/pamm/investor-account/money-managers/${data.id ? data.id : data._id}`);
      return;
    }

    router.push(`/pamm/investor-account/my-investment/${data.idUserInvestment}`);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("colgroup", null, [
        _createElementVNode("col", {
          style: _normalizeStyle(_unref(screenSizes).xs ? 'width: 110px' : 'width: 320px')
        }, null, 4),
        _cache[1] || (_cache[1] = _createElementVNode("col", { style: {"width":"150px"} }, null, -1)),
        _cache[2] || (_cache[2] = _createElementVNode("col", { style: {"width":"320px"} }, null, -1)),
        _cache[3] || (_cache[3] = _createElementVNode("col", { style: {"width":"320px"} }, null, -1)),
        _cache[4] || (_cache[4] = _createElementVNode("col", { style: {"width":"150px"} }, null, -1))
      ]),
      _cache[10] || (_cache[10] = _createElementVNode("thead", null, [
        _createElementVNode("tr", { class: "header" }, [
          _createElementVNode("th", { class: "text-nowrap" }, "Managers"),
          _createElementVNode("th", { class: "text-nowrap" }, "Profit"),
          _createElementVNode("th", { class: "text-nowrap" }, "Min Investment"),
          _createElementVNode("th", { class: "text-nowrap" }, "Manager Fee"),
          _createElementVNode("th", { class: "text-nowrap" }, "Overview")
        ])
      ], -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.pammManager, (data, index) => {
        return (_openBlock(), _createElementBlock("tr", { key: index }, [
          _createElementVNode("td", null, [
            _createElementVNode("div", {
              class: "d-flex pointer",
              onClick: ($event: any) => (toLink(data))
            }, [
              _createVNode(_unref(NAvatar), {
                round: "",
                size: "large",
                src: data?.persona?.profile_pic_url || '/assets/img/avatar.svg',
                alt: data?.manager_detail?.Name,
                class: "mr-2"
              }, null, 8, ["src", "alt"]),
              _createElementVNode("div", null, [
                _createElementVNode("h6", {
                  class: "font-weight-bold mb-0 text-ellipsis",
                  style: _normalizeStyle(_unref(screenSizes).xs ? 'width: 110px' : 'width: 320px')
                }, _toDisplayString(data?.manager_detail?.Name || "-"), 5),
                _createElementVNode("small", _hoisted_3, " ID : " + _toDisplayString(data?.manager_detail?.Id || "-"), 1),
                (data.statusInvestment)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                      _createVNode(_unref(NTag), {
                        class: "ml-2",
                        round: "",
                        size: "small",
                        bordered: false,
                        type: data.statusInvestment === 'connected' ? 'success' : data.status === 'disconnected' ? 'error' : data.status === 'pending' ? 'warning' : 'default'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(data.statusInvestment), 1)
                        ]),
                        _: 2
                      }, 1032, ["type"]),
                      (data.statusInvestment === `pending-disconnect` || data.statusInvestment === `pending`)
                        ? (_openBlock(), _createBlock(_unref(NPopover), {
                            key: 0,
                            trigger: "hover",
                            placement: "right"
                          }, {
                            trigger: _withCtx(() => [
                              _createVNode(_unref(NIcon), { class: "ml-2" }, {
                                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                  _createElementVNode("i", { class: "fa-solid fa-circle-info" }, null, -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _cache[6] || (_cache[6] = _createElementVNode("span", null, "please wait for money manager approval", -1))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 8, _hoisted_2)
          ]),
          _createElementVNode("td", {
            class: _normalizeClass(data?.manager_detail?.TotalProfit < 0 ? 'red' : 'green')
          }, _toDisplayString(_unref(normalizeFloat)(data?.manager_detail?.TotalProfit || 0, {
            toFixed: 2,
          })) + " % ", 3),
          _createElementVNode("td", null, [
            _createElementVNode("p", null, _toDisplayString(_unref(normalizeFloat)(data?.manager_detail?.MinInvestment || 0, {
              toFixed: 2,
            })) + " USD ", 1)
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", null, [
                _cache[7] || (_cache[7] = _createElementVNode("span", null, "Trading Period :", -1)),
                _createTextVNode(" " + _toDisplayString(data?.penalty_setting?.period_setting?.minimum_day_invest || 0) + " Days ", 1)
              ]),
              _createElementVNode("p", null, [
                _cache[8] || (_cache[8] = _createElementVNode("span", null, "Join Fee :", -1)),
                _createTextVNode(" " + _toDisplayString(_unref(normalizeFloat)(countJoinFee(data), {
                toFixed: 2,
              })) + " % ", 1)
              ]),
              _createElementVNode("p", null, [
                _cache[9] || (_cache[9] = _createElementVNode("span", null, "Performance Fee :", -1)),
                _createTextVNode(" " + _toDisplayString(_unref(normalizeFloat)(countPerformanceFee(data), {
                toFixed: 2,
              })) + " % ", 1)
              ])
            ])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(ChartCustome, {
                type: "lineChart",
                data: data.performanceHistory,
                isProfit: data?.manager_detail?.TotalProfit >= 0
              }, null, 8, ["data", "isProfit"])
            ])
          ])
        ]))
      }), 128))
    ]),
    _createVNode(AlertPopup, {
      "is-open": isOpen.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = $event))
    }, null, 8, ["is-open"])
  ], 64))
}
}

})